<template>
  <Modal v-model="editUserModal" :title="editUserTitle" width="1000" :transfer="false" class-name="editUserModalStyle"
    :mask-closable="false" @on-visible-change="editUserChange">
    <div class="details_box_styles">
      <!--基本资料-->
      <div class="basic_information_box">
        <Card :bordered="true" dis-hover>
          <template #title>
            <h2 class="title_box">{{ $t('key1005186') }}</h2>
          </template>
          <Row type="flex" :gutter="gutterItem" class="mb10" v-if="userType ==='look'">
            <Col :span="ItemCol" class="basic_item">
              <span class="basic_title">{{ $t('key1001174') }}</span>
              <span class="basic_txt">{{ editUserForm.mobile }}</span>
            </Col>
            <Col :span="ItemCol" class="basic_item">
              <span class="basic_title">{{ $t('key1000068') }}</span>
              <span class="basic_txt">{{ editUserForm.email }}</span>
            </Col>
            <Col :span="ItemCol" class="basic_item">
              <span class="basic_title">{{ $t('key1002676') }}</span>
              <span class="basic_txt">{{ editUserForm.userName }}</span>
            </Col>
          </Row>
          <Form v-else ref="editUserForm" :model="editUserForm" :rules="ruleValidate" :label-width="labelWidth" @submit.native.prevent>
            <Row style="width: 60%">
              <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
                <Form-item :label="$t('key1001174')" prop="mobile">
                  <Input :placeholder="$t('key1001001')" v-model.trim="editUserForm.mobile" clearable></Input>
                </Form-item>
              </Col>
              <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
                <Form-item :label="$t('key1000068')" prop="email">
                  <Input :placeholder="$t('key1001178')" v-model.trim="editUserForm.email" clearable></Input>
                </Form-item>
              </Col>
              <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
                <Form-item :label="$t('key1002676')" prop="userName">
                  <Input :placeholder="$t('key1003147')" v-model.trim="editUserForm.userName" clearable></Input>
                </Form-item>
              </Col>
              <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
                <Form-item :label="$t('key1002791')" prop="password">
                  <div class="flex align-items-center justify-content-between">
                    <Input style="width: 70%" v-model.trim="editUserForm.password" :placeholder="$t('key1001005')" :element-id="'editUserForm_password'" clearable></Input>
                    <Button style="width: 28%; padding: 0 5px;" @click="getStrongPassword('editUserForm', 'password')">{{ $t('key1005858') }}</Button>
                  </div>
                </Form-item>
              </Col>
            </Row>
          </Form>
        </Card>
      </div>
      <!--所属角色-->
      <div class="basic_information_box" v-if="!isAdmin">
        <Card :bordered="true" dis-hover>
          <template #title>
            <h2 class="title_box">{{ $t('key1005187') }}</h2>
          </template>
          <div class="checkbox_list_styles" v-if="userType === 'look'">
            <span class="checkbox_item" v-for="(item,index) in roleNameList" :key="index">{{ item.roleName }}</span>
          </div>
          <CheckboxGroup v-else v-model="selectRoleList" class="checkbox_list_styles">
            <Checkbox class="checkbox_item" :label="item.roleId" v-for="(item,index) in roleList" :key="index">{{ item.roleName }}</Checkbox>
          </CheckboxGroup>
        </Card>
      </div>
      <!--店铺权限-->
      <div class="basic_information_box" v-if="!isAdmin">
        <Card :bordered="true" dis-hover>
          <template #title>
            <h2 class="title_box">{{ $t('key1005859') }}</h2>
          </template>
          <Tree
            @on-check-change="selectCheckBox"
            :data="storeList"
            :show-checkbox="userType !=='look'">
          </Tree>
        </Card>
      </div>
    </div>
    <template #footer>
      <Button @click="editUserModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" v-if="userType === 'look'" @click="editBtn">{{ $t('key1000985') }}</Button>
      <Button type="primary" v-else @click="editUserBtn">{{ $t('key1000111') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from "@/components/mixin/common_mixin";
import api from '@/api/';
import {commonLocalStorage} from "@/utils/common";

export default {
  name: "editUserModal",
  mixins: [Mixin],
  props: {
    roleList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    let v = this;
    return {
      ItemCol: 24,
      editUserModal: false,
      editUserTitle: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005855'),
      userType: 'add',
      editUserForm: {
        userName: '',
        email: '',
        mobile: '',
        password: '',
      },
      ruleValidate: {
        userName: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002669'), trigger: 'blur'}
        ],
        mobile: [
          {required: true, validator: v.validateMobile(), trigger: 'blur'}
        ],
        email: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005183'), trigger: 'blur'}
        ],
        password: [
          {required: true, validator: v.validatePass(), trigger: 'blur'}
        ],
      },
      selectRoleList: [],
      storeList: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110'),
          expand: true,
          children: []
        }
      ],
      userId: null,
      roleNameList: [],
      platformStoreList: [],
      isAdmin: false, // 是否是管理员
    }
  },
  computed: {
    // 跨境电商平台配置
    distributorPlatformSet() {
      const obj = commonLocalStorage.getItem('configurationItemInfo') ?? this.$store.state.configurationItemInfo;
      return obj?.distributorPlatformSet || [];
    }
  },
  methods: {
    // 初始化数据
    initFun(type, userId) {
      let titleObj = {
        add: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005855'),
        edit: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005856'),
        look: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005854')
      };
      this.editUserTitle = titleObj[type];
      this.userType = type;
      this.userId = userId;
      if (type === 'add') {
        this.getPlatformStoreList();
        this.editUserModal = true;
      } else {
        this.getUserInfo();
      }
    },
    // 获取所有平台店铺
    getPlatformStoreList(newList) {
      let v = this;
      v.storeList = [];
      v.axios.post(api.post_ymsPlatformAccount_queryAll).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas || [];
          if (data.length > 0) {
            if (v.userType === 'look') {
              data = data.filter((item) => {
                if (newList && newList.length > 0) {
                  if (item.ymsPlatformAccountId) {
                    if (newList.includes(item.ymsPlatformAccountId)) {
                      return item;
                    }
                  }
                }
              })
            } else {
              data.map((item) => {
                item.expand = false;
                if (newList && newList.length > 0) {
                  if (item.ymsPlatformAccountId) {
                    if (newList.includes(item.ymsPlatformAccountId)) {
                      item.checked = true;
                    }
                  }
                }
              });
            }
            if (v.distributorPlatformSet.length > 0) {
              let newData = data.filter((item) => {
                return v.distributorPlatformSet.includes(item.platformId);
              });
              let list = v.handerGrouping(newData, function (item) {
                return [item.platformId];
              }, 'platformId', 'children');
              if (list.length > 0) {
                list.map((item) => {
                  item.title = item.platformId;
                  if (item.children && item.children.length > 0) {
                    item.children.map((ele) => {
                      ele.title = ele.code;
                    })
                  }
                });
                v.storeList = [
                  {
                    title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110'),
                    expand: true,
                    children: list
                  }
                ]
              }
            }
          }
        }
      });
    },
    // 获取员工详情信息
    getUserInfo() {
      let v = this;
      v.axios.post(api.post_ymsDistributorUserInfo_id + v.userId, {}, {loading: true}).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          let keyList = ['userName', 'email', 'mobile'];
          for (let key in data) {
            if (keyList.includes(key)) {
              v.editUserForm[key] = data[key];
            }
          }
          v.selectRoleList = data.roleIdList;
          v.roleNameList = v.roleList.filter((item) => {
            if (data.roleIdList.includes(item.roleId)) {
              return item;
            }
          });

          if (data.ymsPlatformAccountUserRelateds && data.ymsPlatformAccountUserRelateds.length > 0) {
            this.platformStoreList = data.ymsPlatformAccountUserRelateds;
            let newList = data.ymsPlatformAccountUserRelateds.map((item) => {
              return item.ymsPlatformAccountId;
            });
            if (newList.length > 0) {
              v.getPlatformStoreList(newList);
            }
          } else {
            if (v.userType === 'edit') {
              v.getPlatformStoreList();
            } else {
              v.storeList = [];
            }
          }
          v.editUserModal = true;
        }
      });
    },

    // 切换到编辑状态
    editBtn() {
      this.initFun('edit', this.userId);
    },
    // 勾选中的店铺权限值
    selectCheckBox(arr) {
      this.platformStoreList = arr;
    },
    // 新增、编辑用户的确定按钮
    editUserBtn() {
      let v = this;
      let url = '';
      let text = '';
      let method = '';
      let query = JSON.parse(JSON.stringify(v.editUserForm));
      // 新增员工
      if (v.userType === 'add') {
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000776');
        method = 'post';
        url = api.post_ymsDistributorUserInfo;
      }
      // 编辑员工
      else if (v.userType === 'edit') {
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001205');
        method = 'put';
        url = api.put_ymsDistributorUserInfo;
        query.userId = v.userId;
        if (query.password === '') {
          delete query.password;
        }
      }
      query.roleIdList = v.selectRoleList;
      let ymsPlatformAccountUserRelateBos = [];
      if (v.platformStoreList.length > 0) {
        let list = v.handerGrouping(v.platformStoreList, function (item) {
          return [item.platformId];
        }, 'platformId', 'children');
        if (list.length > 0) {
          list.map((ele) => {
            let obj = {
              platformId: ele.platformId,
              ymsPlatformAccountIds: []
            }
            if (ele.children && ele.children.length > 0) {
              ele.children.map((talg) => {
                if (talg.ymsPlatformAccountId) {
                  obj.ymsPlatformAccountIds.push(talg.ymsPlatformAccountId);
                }
              })
            }
            if (obj.ymsPlatformAccountIds.length > 0) {
              ymsPlatformAccountUserRelateBos.push(obj);
            }
          })
        }
      }
      query.ymsPlatformAccountUserRelateBos = ymsPlatformAccountUserRelateBos || [];
      v.$refs['editUserForm'].validate((valid) => {
        if (valid) {
          v.axios[method](url, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247'),}).then(response => {
            if (response.data.code === 0) {
              v.editUserModal = false;
              v.$Message.success(text);
              v.$emit('updateData', true);
            } else if (response.data.code === 101107) {
              v.editUserModal = false;
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005857'));
              v.$emit('updateData', true);
            }
          });
        }
      });
    },
    // 监听弹窗
    editUserChange(value) {
      if (!value) {
        this.editUserForm.userName = '';
        this.editUserForm.email = '';
        this.editUserForm.mobile = '';
        this.editUserForm.password = '';
        this.userType = 'add';
        this.roleNameList = [];
        this.storeList = [
          {
            title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110'),
            expand: true,
            children: []
          }
        ];
        this.platformStoreList = [];
        this.selectRoleList = [];
      }
    },
    // 密码校验
    validatePass() {
      let v = this;
      let isnoMatchChinese = v.$regular.noMatchChinese;
      return function (rule, value, callback) {
        if (v.userType === 'add') {
          if (value === '') {
            callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000143')));
          } else if (isnoMatchChinese.test(value)) {
            callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000144')));
          }
        }
        callback();
      };
    },
  }
}
</script>

<style lang="less" scoped>
/deep/ .editUserModalStyle {
  .ivu-modal-body {
    max-height: 700px;
    overflow-y: auto;
  }

  .basic_information_box {
    .checkbox_list_styles {
      .checkbox_item {
        margin: 0 30px 10px 0;
        display: inline-block;
      }
    }

    .ivu-tree-title-selected, .ivu-tree-title-selected:hover, .ivu-tree-title:hover {
      background-color: transparent !important;
    }
  }
}
</style>